export default __webpack_public_path__ + "static/media/calendar-date.d3d34572.svg";